import { Injectable, signal } from '@angular/core';

/**
 * Controla la visibilidad del modal completo del Quiz que aparece cuando el
 * backend rechaza una operación con código CU010 (usuario debe completar su
 * validación). El modal vive en el shell raíz para que pueda mostrarse sobre
 * cualquier vista (típicamente el dashboard).
 */
@Injectable({ providedIn: 'root' })
export class QuizModalService {
  private readonly isOpenSignal = signal<boolean>(false);
  readonly isOpen = this.isOpenSignal.asReadonly();

  open(): void {
    this.isOpenSignal.set(true);
  }

  close(): void {
    this.isOpenSignal.set(false);
  }
}
